module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("control_select", [["div",{"class":"common-widget-control-select"},[["span",{"class":"current-value"},[["textNode",{"text":"Select item"}]]],["textNode",{"text":" "}],["span",{"class":"drop-arrow"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/common-widgets/select.a.tpl
// module id = 607
// module chunks = 4